import { ellipsis, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const emailWrapper: ThemedFunctor = () => css`
  width: 7rem;
  ${ellipsis()}
`;
